
enum SITUATION  {
  succeeded = "Aprovada",
  enabled = "Ativado",
  Active = "Ativo",
  failed = "Falhada",
  pending = "Pendente",
  canceled = "Cancelada"
}

export function translateStatus (status: string) {
  return SITUATION[status as keyof typeof SITUATION] ?? null;
}
